/** 0n Brand Tokens — single source of truth for all 0n ecosystem sites */

export const ON_BRAND = {
  bg: {
    primary: '#0d1117',
    secondary: '#161b22',
    tertiary: '#1c2333',
    card: '#161b22',
    sidebar: '#0d1117',
    header: 'rgba(13,17,23,0.85)',
    deep: '#040A1A',
    vault: '#081C4F',
  },
  text: {
    primary: '#f0f4f8',
    secondary: '#9ca3af',
    muted: '#6b7280',
    onDark: '#E0E0E0',
  },
  accent: {
    brand: '#6EE05A',
    dim: '#5cb83a',
    glow: 'rgba(110,224,90,0.15)',
  },
  border: {
    default: '#30363d',
    hover: 'rgba(255,255,255,0.12)',
    subtle: 'rgba(255,255,255,0.06)',
  },
  core: {
    green: '#6EE05A',
    cyan: '#14b8a6',
    purple: '#8b5cf6',
    red: '#ef4444',
    amber: '#f59e0b',
    orange: '#FF6B35',
    teal: '#00C2C7',
  },
  font: {
    sans: "'Inter', ui-sans-serif, system-ui, sans-serif",
    body: "'Nunito Sans', 'Inter', system-ui, sans-serif",
    mono: "'Roboto Mono', 'JetBrains Mono', ui-monospace, monospace",
  },
  radius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.625rem',
    xl: '0.875rem',
    '2xl': '1.125rem',
  },
  gradient: {
    heading: 'linear-gradient(135deg, #6EE05A 0%, #00C2C7 100%)',
    headingAlt: 'linear-gradient(135deg, #6EE05A 0%, #14b8a6 50%, #00C2C7 100%)',
  },
} as const

export type OnBrand = typeof ON_BRAND
